import { z } from 'zod'

export const MCPSERVER_JSONRPC_CONTRACT_VERSION = '1.0.0' as const

export const mcpserverJsonRpcRequestSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
  method: z.string().min(1),
  params: z.record(z.unknown()).optional(),
}).passthrough()

export const mcpserverJsonRpcResponseSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
}).passthrough()

export const mcpserverSseMessageResponseSchema = z.object({
  error: z.string(),
  message: z.string(),
}).passthrough()

export type McpserverSseMessageResponse = z.infer<typeof mcpserverSseMessageResponseSchema>

export type McpserverJsonRpcRequest = z.infer<typeof mcpserverJsonRpcRequestSchema>
export type McpserverJsonRpcResponse = z.infer<typeof mcpserverJsonRpcResponseSchema>
